export default {
  success: { iconClass: 'InfoBar-text--noticeIcon', messageClass: 'InfoBar-content--notice' },
  error: { iconClass: 'InfoBar-text--alertIcon', messageClass: 'InfoBar-content--alert'}
}
